<template>
  <div id="story-view" >
    <nav-header v-if="!isMobile"></nav-header>
    <div class="story-header">
      <router-link to="/">
        <img class="logo-story" src="~@/../static/logo/story_logo.png"/>
      </router-link>
      <div class="toggle-button hambuger-icon" @click="openMenu" v-if="isMobile">☰</div>
    </div>
    <div v-if="loaded && story.length" id="story-container" v-hammer:swipe="clickSwipe">
        <div class="arrow-container arrow-left" @click="slideLeft"  v-bind:class="{hidden: isFirstStep}"></div>
        <div class="slide-main">
          <div class="slide-container" v-for="(step, i) in story" v-if="i == currentStoryId">
            <story-step :stepId="currentStoryId" :isLast="i == story.length - 1" class="story-step" v-bind:data="step" :key="i"/>
          </div>
        </div>
        <div class="arrow-container arrow-right" @click="slideRight" v-show="!isLastStep"></div>
    </div>
    <div v-else class="loading-panel">
      <loader :isYellow="true"></loader>
    </div>
    <story-step-age v-bind:data="story"/>
  </div>
</template>

<script>
  import StoryApi from '@/api/StoryApi'
  import StoryStep from "../components/StoryStep";
  import StepIndicator from 'vue-step-indicator'
  import 'vue-step-indicator/dist/vue-step-indicator.css'
  import NavHeader from "../components/NavHeader";
  import StoryStepAge from "../components/StoryStepAge";
  import Loader from "../components/Loader";
  import { VueHammer } from 'vue2-hammer'


  export default {
    components: {
      StoryStepAge,
      NavHeader,
      Loader,
      StepIndicator, StoryStep},
    name: "story",
    computed: {
      currentStory() {
        if (this.story.length > 0)
          return this.story[this.$store.state.storyStep]
        else
          return {}
      },
      currentStoryId() {
        return this.$store.state.storyStep;
      },
      stepLeft(){
        return 40 - this.$store.state.storyStep * 19
      },
      isLastStep () {
        return this.$store.state.storyStep == this.story.length - 1
      },
      isFirstStep () {
        return this.$store.state.storyStep == 0
      },
      isMobile(){
        return this.$store.state.isMobile
      },
      story () {
        return this.$store.state.storyLoaded ? this.$store.state.storyData : []
      },
      loaded () {
        return this.$store.state.storyLoaded
      }
    },
    created() {
      this.loadData()
    },
    mounted () {
      this.loadData()
    },
    updated() {
      //this.$refs.slick.reSlick();
    },
    methods: {
      /*async getStory () {
        gapi = await this.$getGapiClient()

        const storyData = await StoryApi.getStoryData(gapi)
        this.story = storyData
      },*/
      loadData () {
        !this.$store.state.storyLoaded && this.$getGapiClient().then(gapi => {
          this.$store.commit('getStoryData', gapi)
        })
      },
      clickSwipe(event){
        if(event.direction == 4 && this.$store.state.storyStep > 0)
          this.slideLeft()
        if(event.direction == 2 && this.$store.state.storyStep < this.story.length - 1)
          this.slideRight()
      },
      slideLeft(){
        if(this.$store.state.storyStep > 0)
          this.$store.commit('setStoryStep', this.$store.state.storyStep - 1 )
      },
      slideRight(){
        if(this.$store.state.storyStep < this.story.length - 1)
          this.$store.commit('setStoryStep', this.$store.state.storyStep + 1 )
      },
      openMenu(event){
        this.$emit('openMenu')
        event.stopPropagation();
      }
    }
  }
</script>

<style scoped>
  #story-view{
    height: 100vh
  }
  #story-container{
    height: calc(100vh - 180px);
    position: relative;
    overflow: auto;
    display: flex;
    flex-direction: row;
  }
  .arrow-container {
    width: 10%;
    height: calc(100vh - 190px);
    background: red;
    display: flex;
  }
  .arrow-container.hidden {
    opacity: 0
  }
  .arrow-container.arrow-left{
    background: url('~@/../static/icons/arrow-left.svg') no-repeat center center;
    background-size: 12px;
  }
  .arrow-container.arrow-right{
    background: url('~@/../static/icons/arrow-right.svg') no-repeat center center;
    background-size: 12px;
  }

  .slide-main{
    width: 80%;
  }
  .slide-container{
    position:absolute;
    width: 80%;
    height: calc(100vh - 190px);
    left: 10%;
    margin-bottom: 20px;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .8s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  #step-container{
    width: 100%;
    position: absolute;
    bottom: 10px;
    overflow: hidden;
  }
  .step-indicators{
    width: 200%;
  }
.story-header{
  display: flex;
  width: 80%;
  margin: 0 10%;
  min-height: 50px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.toggle-button{
  margin-left: auto;
  font-size: 30px;
  color: #f8d83c;
  margin-top: 10px;
}
.logo-story{
  margin-top: 10px;
  height: 50px;
}
.share-icon{
  height: 40px;
  margin-left: auto;
  margin-right: 20px;
}
.loading-panel{
  position: absolute;
  top: 50%;
  transform: translateX(-50%);
  left: 50%;
}
@media only screen and (min-width: 768px) {
  .story-header a{
    display: flex;
    margin-left: 0;
  }
  .ar .story-header a{
      display: flex;
      margin-left: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Story.vue